import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { AuthButtons } from '../auth';

/**
 * SPLICEWebサイトヘッダーコンポーネント
 * ナビゲーションメニューとロゴを含む
 */
const Header: React.FC = () => {
  const location = useLocation();

  // ナビゲーションアイテムがアクティブかどうかを判定
  const isActive = (path: string): string => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <nav className="navbar navbar-expand-md navbar-light bg-white border-bottom shadow-sm" style={{ height: '120px' }}>
      <div className="container-fluid">
        {/* ロゴ */}
        <Link className="navbar-brand" to="/">
          <img 
            src="/img/splice_logo.png" 
            alt="SPLICE建築企画のロゴ" 
            className="navbar-logo img-fluid"
          />
        </Link>

        {/* モバイル用ハンバーガーメニュー */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarNavDropdown" 
          aria-controls="navbarNavDropdown" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* ナビゲーションメニュー */}
        <div className="collapse navbar-collapse pe-5" id="navbarNavDropdown">
          <ul className="navbar-nav me-auto">
            <li className="nav-item">
              <Link className={isActive('/archi')} to="/archi">
                建築設計
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/realestate')} to="/realestate">
                不動産
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/others')} to="/others">
                その他
              </Link>
            </li>
            
            {/* 会社概要 */}
            <li className="nav-item">
              <Link className={isActive('/company')} to="/company">
                会社概要
              </Link>
            </li>
          </ul>

          {/* 右側のメニュー（認証機能） */}
          <AuthButtons />
        </div>
      </div>
    </nav>
  );
};

export default Header; 